<template>
  <div class="xf-radio-box" v-if="showRadioBox">
    <div class="radio-box-container">
      <div class="radio-header">
        <div class="header-content">
          <span class="header-text">{{ title }}</span>
          <span class="iconfont iconguanbi icon-reset" @click="close"></span>
        </div>
      </div>
      <div class="radio-content">
        <div class="radio-select">
          <div class="username">
            <label>{{ firstName }}</label>
            <input
              type="radio"
              name="firstusername"
              :value="firstName"
              ref="firstName"
            />
          </div>
          <div class="username">
            <label>{{ secondName }}</label>
            <input
              type="radio"
              name="firstusername"
              :value="secondName"
              ref="secondName"
            />
          </div>
          <div class="clear"></div>
        </div>
        <div class="radio-message">
          <div class="notice">重要提示:</div>
          <div class="message-content">
            选择保留的用户名将为您登录MOOC学院系统的唯一用户名，您可使用该用户名及密码一站式访问MOOC学院、职教云及智慧职教。另一用户名将不能使用。
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="radio-footer">
        <button class="btn btn-confirm" @click="confirm">
          {{ confirmText }}
        </button>
        <button class="btn btn-confirm" @click="loginDeraction">
          {{ loginText }}
        </button>
        <button class="btn btn-cancel" v-show="isShowCancel" @click="cancel">
          {{ cancelText }}
        </button>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "xfRadioBox",
  props: {
    title: {
      type: String,
      default: "提示信息"
    },
    showRadioBox: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "这是测试用的消息"
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    loginText: {
      type: String,
      default: "直接登录"
    },
    isShowCancel: {
      type: Boolean,
      default: true
    },
    infoIcon: {
      type: String,
      default: "/assets/images/icon-info.png"
    },
    firstName: {
      type: String
    },
    secondName: {
      type: String
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      let firstName = this.$refs.firstName.checked;
      let secondName = this.$refs.secondName.checked;
      let mergeValue = "";
      if (firstName) {
        mergeValue = this.$refs.firstName.value;
      }
      if (secondName) {
        mergeValue = this.$refs.secondName.value;
      }
      this.$emit("confirm", mergeValue);
    },
    cancel() {
      this.$emit("cancel");
    },
    loginDeraction() {
      this.$emit("loginDeraction");
    }
  }
};
</script>
